import React, { useEffect, useState } from 'react';
import { TRANSPORT_SEARCH_API, TRANSPORTER_UPDATE, SUB_TRANSPORTER_UPDATE } from '../../config/api';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';

function TransportSearch() {
  const [transporters, setTransporters] = useState([]);
  const [editingTransporterId, setEditingTransporterId] = useState(null);
  const [editingSubId, setEditingSubId] = useState(null);
  const [formData, setFormData] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [triggerSearch, setTriggerSearch] = useState(false); // trigger manually

  useEffect(() => {
    fetchTransporters();
  }, [triggerSearch]); // only refetch on button click

  const fetchTransporters = async () => {
    try {
      const res = await fetch(TRANSPORT_SEARCH_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: 1, search_term: searchTerm })
      });
      const data = await res.json();
      if (data.success) {
        setTransporters(data.records || []);
      }
    } catch (err) {
      console.error('Error fetching transporters:', err);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const startEditTransporter = (t) => {
    setEditingTransporterId(t.id);
    setFormData({
      name: t.name,
      contact_person: t.contact_person,
      mobile: t.mobile,
      email: t.email,
    });
  };

  const startEditSub = (sub) => {
    setEditingSubId(sub.id);
    setFormData({
      name: sub.name,
      contact_person: sub.contact_person,
      mobile: sub.mobile,
      email: sub.email,
    });
  };

  const cancelEdit = () => {
    setEditingTransporterId(null);
    setEditingSubId(null);
    setFormData({});
  };

  const saveTransporter = async (id) => {
    try {
      const res = await fetch(TRANSPORTER_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, ...formData, user_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        cancelEdit();
        setTriggerSearch(prev => !prev); // refresh list
      } else {
        alert(data.message || 'Failed to update');
      }
    } catch (err) {
      alert('Error updating transporter');
    }
  };

  const saveSubTransporter = async (id) => {
    try {
      const res = await fetch(SUB_TRANSPORTER_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, ...formData, user_id: 1 })
      });
      const data = await res.json();
      if (data.success) {
        cancelEdit();
        setTriggerSearch(prev => !prev); // refresh list
      } else {
        alert(data.message || 'Failed to update');
      }
    } catch (err) {
      alert('Error updating sub-transporter');
    }
  };

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
      <Navbar />
      <div className="container mt-4">
        <h4 className="mb-3">Transporter & Sub-Transporter Search</h4>

        <div className="row mb-3">
          <div className="col-md-10">
            <input
              type="text"
              className="form-control"
              placeholder="Search transporter or sub-transporter..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-primary w-100"
              onClick={() => setTriggerSearch(prev => !prev)}
            >
              Search
            </button>
          </div>
        </div>

        {transporters.length === 0 ? (
  <div className="alert alert-warning text-center">No matching records found.</div>
) : (
  <>
    {/* Desktop Table View */}
    <div className="table-responsive d-none d-md-block">
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Transporter Name</th>
            <th>Contact Person</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Action</th>
            <th>Sub-Transporters</th>
          </tr>
        </thead>
        <tbody>
          {transporters.map((t, index) => (
            <tr key={t.id}>
              <td>{index + 1}</td>
              <td>
                {editingTransporterId === t.id ? (
                  <input className="form-control" name="name" value={formData.name} onChange={handleChange} />
                ) : t.name}
              </td>
              <td>
                {editingTransporterId === t.id ? (
                  <input className="form-control" name="contact_person" value={formData.contact_person} onChange={handleChange} />
                ) : t.contact_person}
              </td>
              <td>
                {editingTransporterId === t.id ? (
                  <input className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} />
                ) : t.mobile}
              </td>
              <td>
                {editingTransporterId === t.id ? (
                  <input className="form-control" name="email" value={formData.email} onChange={handleChange} />
                ) : t.email}
              </td>
              <td>
                {editingTransporterId === t.id ? (
                  <>
                    <button className="btn btn-sm btn-success me-1" onClick={() => saveTransporter(t.id)}>Save</button>
                    <button className="btn btn-sm btn-secondary" onClick={cancelEdit}>Cancel</button>
                  </>
                ) : (
                  <button className="btn btn-sm btn-warning" onClick={() => startEditTransporter(t)}>Edit</button>
                )}
              </td>
              <td>
                {t.sub_transporters?.length > 0 ? (
                  <table className="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Contact</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {t.sub_transporters.map(sub => (
                        <tr key={sub.id}>
                          <td>
                            {editingSubId === sub.id ? (
                              <input className="form-control" name="name" value={formData.name} onChange={handleChange} />
                            ) : sub.name}
                          </td>
                          <td>
                            {editingSubId === sub.id ? (
                              <input className="form-control" name="contact_person" value={formData.contact_person} onChange={handleChange} />
                            ) : sub.contact_person}
                          </td>
                          <td>
                            {editingSubId === sub.id ? (
                              <input className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} />
                            ) : sub.mobile}
                          </td>
                          <td>
                            {editingSubId === sub.id ? (
                              <input className="form-control" name="email" value={formData.email} onChange={handleChange} />
                            ) : sub.email}
                          </td>
                          <td>
                            {editingSubId === sub.id ? (
                              <>
                                <button className="btn btn-sm btn-success me-1" onClick={() => saveSubTransporter(sub.id)}>Save</button>
                                <button className="btn btn-sm btn-secondary" onClick={cancelEdit}>Cancel</button>
                              </>
                            ) : (
                              <button className="btn btn-sm btn-warning" onClick={() => startEditSub(sub)}>Edit</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <span className="text-muted">No sub-transporters</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Mobile Card View */}
    <div className="d-block d-md-none">
      {transporters.map((t, index) => (
        <div className="card mb-3" key={t.id}>
          <div className="card-body">
            <h5 className="card-title">{index + 1}. {t.name}</h5>
            {editingTransporterId === t.id ? (
              <>
                <input className="form-control mb-1" name="name" value={formData.name} onChange={handleChange} />
                <input className="form-control mb-1" name="contact_person" value={formData.contact_person} onChange={handleChange} />
                <input className="form-control mb-1" name="mobile" value={formData.mobile} onChange={handleChange} />
                <input className="form-control mb-2" name="email" value={formData.email} onChange={handleChange} />
                <button className="btn btn-sm btn-success me-1" onClick={() => saveTransporter(t.id)}>Save</button>
                <button className="btn btn-sm btn-secondary" onClick={cancelEdit}>Cancel</button>
              </>
            ) : (
              <>
                <p className="card-text mb-1"><strong>Contact:</strong> {t.contact_person}</p>
                <p className="card-text mb-1"><strong>Mobile:</strong> {t.mobile}</p>
                <p className="card-text mb-2"><strong>Email:</strong> {t.email}</p>
                <button className="btn btn-sm btn-warning" onClick={() => startEditTransporter(t)}>Edit</button>
              </>
            )}

            <h6 className="card-subtitle mt-3 mb-2 text-muted">Sub-Transporters</h6>
            {t.sub_transporters?.length > 0 ? (
              <ul className="list-group list-group-flush">
                {t.sub_transporters.map((s, i) => (
                  <li className="list-group-item px-0" key={s.id}>
                    {editingSubId === s.id ? (
                      <>
                        <input className="form-control mb-1" name="name" value={formData.name} onChange={handleChange} />
                        <input className="form-control mb-1" name="contact_person" value={formData.contact_person} onChange={handleChange} />
                        <input className="form-control mb-1" name="mobile" value={formData.mobile} onChange={handleChange} />
                        <input className="form-control mb-2" name="email" value={formData.email} onChange={handleChange} />
                        <button className="btn btn-sm btn-success me-1" onClick={() => saveSubTransporter(s.id)}>Save</button>
                        <button className="btn btn-sm btn-secondary" onClick={cancelEdit}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <strong>{s.name}</strong><br />
                        <small>{s.contact_person}</small><br />
                        <small>{s.mobile}</small><br />
                        <small>{s.email}</small><br />
                        <button className="btn btn-sm btn-warning mt-1" onClick={() => startEditSub(s)}>Edit</button>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted">No sub-transporters</p>
            )}
          </div>
        </div>
      ))}
    </div>
  </>
)}

      </div>
        <Footer />
        </div>
    </>
  );
}

export default TransportSearch;
